import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CertificationsService from "../../api/certificationsService";
import { formatDate } from "../../utils/helper";

const CertificationsPage = () => {
  const [certifications, setCertifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        setLoading(true);
        const data = await CertificationsService.getAll();
        setCertifications(data);
      } catch (error) {
        console.error("Error fetching certifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertifications();
  }, []);

  const handleAddCertification = () => {
    navigate("/admin/certifications/new");
  };

  const handleEditCertification = (id) => {
    navigate(`/admin/certifications/edit/${id}`);
  };

  const handleDeleteCertification = async (id) => {
    if (window.confirm("Are you sure you want to delete this certification?")) {
      try {
        const token = localStorage.getItem("token");
        await CertificationsService.delete(id, token);
        setCertifications(certifications.filter((cert) => cert.id !== id));
      } catch (error) {
        console.error("Error deleting certification:", error);
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1">
          Certifications
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddCertification}
        >
          Add New Certification
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Icon</TableCell>
              <TableCell>Obtained Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {certifications.length > 0 ? (
              certifications.map((cert) => (
                <TableRow key={cert.id}>
                  <TableCell>{cert.name}</TableCell>
                  <TableCell>
                    <img
                      src={cert.icon}
                      alt={cert.name}
                      style={{ width: 64, height: 64 }}
                    />
                  </TableCell>
                  <TableCell>{formatDate(cert.obtainedDate)}</TableCell>
                  <TableCell>{cert.isActive ? "Active" : "Inactive"}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => handleEditCertification(cert.id)}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleDeleteCertification(cert.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                  No certifications found. Create your first certification!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CertificationsPage;
